(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpenglanz-collection-intro"]) return;
  try {
    
  if (!customElements.get('alpenglanz-collection-filters')) {
    customElements.define('alpenglanz-collection-filters', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.grid = document.querySelector('#ResultsList .product-grid');
        if (!this.grid) return;
        this.initialized = true;
        const products = JSON.parse(this.querySelector('[data-alpen-collection-products]').textContent);
        this.products = new Map(products.map(product => [String(product.id), product]));
        this.cards = [...this.grid.querySelectorAll('.product-grid__item')];
        this.budget = this.querySelector('[data-alpen-collection-budget]');
        this.stock = this.querySelector('[data-alpen-collection-stock]');
        this.sort = this.querySelector('[data-alpen-collection-sort]');
        this.status = this.querySelector('[data-alpen-collection-status]');
        this.empty = this.querySelector('[data-alpen-collection-empty]');
        this.querySelector('form').addEventListener('submit', event => {event.preventDefault();this.apply();});
        this.querySelector('form').addEventListener('change', () => this.apply());
      }
      apply() {
        const maximum = this.budget.value ? Number(this.budget.value) * 100 : Infinity;
        let count = 0;
        this.cards.forEach(card => {
          const product = this.products.get(card.dataset.productId);
          card.dataset.alpenFiltered = '';
          card.hidden = product ? product.price > maximum || (this.stock.checked && !product.available) : false;
          if (!card.hidden) count++;
        });
        const cards = [...this.cards];
        const order = this.sort.value;
        if (order) cards.sort((a,b) => {
          const first = this.products.get(a.dataset.productId);
          const second = this.products.get(b.dataset.productId);
          if (!first || !second) return 0;
          if (order === 'title-ascending') return first.title.localeCompare(second.title, document.documentElement.lang);
          return order === 'price-descending' ? second.price - first.price : first.price - second.price;
        });
        cards.forEach(card => this.grid.appendChild(card));
        this.status.hidden = false;
        this.status.textContent = `${count} ${this.dataset.resultLabel}`;
        this.empty.hidden = count !== 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpenglanz-discover"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alpenglanz-gifts')) {
    customElements.define('alpenglanz-gifts', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.recipient = this.querySelector('[data-alpen-recipient]');
        this.budget = this.querySelector('[data-alpen-budget]');
        this.cards = [...this.querySelectorAll('[data-alpen-gift]')];
        this.results = this.querySelector('[data-alpen-results]');
        this.status = this.querySelector('[data-alpen-status]');
        this.empty = this.querySelector('[data-alpen-empty]');
        this.form.addEventListener('submit', event => { event.preventDefault(); this.findGifts(); });
        this.form.addEventListener('change', () => { if (!this.results.hidden) this.findGifts(); });
      }
      findGifts() {
        const category = this.recipient.value;
        const budget = this.budget.value ? Number(this.budget.value) * 100 : Infinity;
        let count = 0;
        this.cards.forEach(card => {
          const matchesCategory = !category || card.dataset.collections.split('|').includes(category);
          card.hidden = !(matchesCategory && Number(card.dataset.price) <= budget);
          if (!card.hidden) count++;
        });
        this.results.hidden = false;
        this.empty.hidden = count !== 0;
        this.status.textContent = `${count} ${this.dataset.resultLabel}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
